import { useEffect, useState } from 'react';
import { useSuccessReactor } from '@livefree/reactive';
import { Link, useSearchParams } from 'react-router';
import { reactive } from '@/core/reactive/reactive';

export const Error = reactive.component(
  ({ services, monitors }) => {
    const [error, setError] = useState(null);
    const [searchParams] = useSearchParams();
    const errorId = searchParams.get('errorId');

    useEffect(() => {
      services.login.getErrorMessage(errorId);
    }, [services, errorId]);

    useSuccessReactor(services.login.getErrorMessage, payload => {
      setError(payload);
    });

    if (!error || monitors.getErrorMessage.executing) {
      return <h5>Loading...</h5>;
    }

    return (
      <>
        <h1>{error.error}</h1>
        <h5>{error.errorDescription}</h5>
        <h5>{error.requestId}</h5>
        <Link to="/">Go back</Link>
      </>
    );
  },
  {
    name: 'Error',
    monitors: services => [services.login.getErrorMessage],
  },
);
